import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

export class FileDownloadUtils {
  /**
   * Fetches url as a blob and triggers a browser download of it as fileName via a throwaway
   * anchor element, revoking the object URL once the click has been dispatched.
   */
  static downloadFromUrl(http: HttpClient, url: string, fileName: string): Observable<Blob> {
    return http.get(url, { responseType: 'blob' }).pipe(
      tap(blob => {
        const objectUrl = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = objectUrl;
        anchor.download = fileName;
        anchor.click();
        URL.revokeObjectURL(objectUrl);
      })
    );
  }
}
